<template>
	<div>
		<div class="header-item">
			<h1>Showpad</h1>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li><router-link to="/showpad">Experience</router-link></li>
								<!-- <li><router-link to="/showpad/config">Config</router-link></li>
								<li><router-link to="/showpad/tags">Tags</router-link></li>
								<li><router-link to="/showpad/stores">Stores</router-link></li> -->
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view></router-view>

	</div>

</template>

<script>

export default {
	name: 'showpad'
}
</script>
